var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7868_25675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.05713 0V1.87539H2.80729V1.5003H2.4322V0.37507H10.684V1.5003H10.3089V1.87539H11.0591V0H2.05713Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56243 2.05664H4.12158V2.42646H6.56243V2.05664Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68865 2.82031H4.12158V3.19013H4.68865V2.82031Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42841 2.82031H5.05859V3.19013H5.42841V2.82031Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99531 2.82031H5.62549V3.19013H5.99531V2.82031Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56269 2.82031H6.19287V3.19013H6.56269V2.82031Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0033 3.75781H4.12158V4.12763H9.0033V3.75781Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0033 4.49805H4.12158V4.86787H9.0033V4.49805Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0033 5.26172H4.12158V5.63154H9.0033V5.26172Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0031 6.00195H8.43604V6.37177H9.0031V6.00195Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0031 6.76562H8.43604V7.13545H9.0031V6.76562Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0031 7.50586H8.43604V7.87568H9.0031V7.50586Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99559 6.9375H2.05078V7.30732H5.99559V6.9375Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49139 7.70312H3.92432V8.07295H4.49139V7.70312Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99547 7.70312H4.86133V8.07295H5.99547V7.70312Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99547 8.44141H4.86133V8.81123H5.99547V8.44141Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49139 8.44141H3.92432V8.81123H4.49139V8.44141Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92456 9.74805H2.05078V10.1179H3.92456V9.74805Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99531 9.74805H5.62549V10.1179H5.99531V9.74805Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42841 9.74805H5.05859V10.1179H5.42841V9.74805Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86103 9.74805H4.49121V10.1179H4.86103V9.74805Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99559 10.6855H2.05078V11.0554H5.99559V10.6855Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75162 9.75495C9.74763 9.75495 9.74367 9.75523 9.73969 9.75526L7.30241 9.74912L7.30149 10.1189L8.91912 10.123C8.73729 10.3225 8.62632 10.5873 8.62632 10.8776C8.62632 11.2927 8.2899 11.6303 7.87641 11.6303C7.87472 11.6303 7.87308 11.6302 7.8714 11.6302V11.6301H7.86603C7.4589 11.6245 7.12939 11.2892 7.12939 10.8776V6.75165C7.12939 6.53987 7.29184 6.37394 7.49921 6.37394C7.70658 6.37394 7.86903 6.53985 7.86903 6.75165V8.06443C7.86903 8.35217 7.97787 8.61488 8.15637 8.81377L7.30227 8.8122L7.30161 9.18202C7.30161 9.18202 8.96895 9.18706 8.99082 9.18706C9.60938 9.18706 10.1126 8.68346 10.1126 8.06446V1.11982H10.3099V0.75H2.81472V1.11982H2.99458V5.81394H3.36965V1.11982H9.74281V8.06446C9.74281 8.47956 9.40545 8.81724 8.99082 8.81724C8.97687 8.81724 8.963 8.8168 8.94921 8.81602V8.81523L8.93867 8.8152C8.54827 8.78827 8.2388 8.46196 8.2388 8.06443V6.75165C8.2388 6.33946 7.907 6.00412 7.49914 6.00412V6.00154H1.68178C1.27326 6.00154 0.940918 6.33803 0.940918 6.75168V10.8776C0.940918 11.1774 1.05653 11.4581 1.26646 11.6678C1.47628 11.8773 1.75701 11.9928 2.05663 11.9928L7.86598 12C7.86945 12 7.87287 12.0002 7.87637 12.0002C8.49378 12.0002 8.99611 11.4966 8.99611 10.8776C8.99611 10.4665 9.32853 10.1316 9.73957 10.1251L9.74785 10.1251V10.1249C9.74911 10.1249 9.75033 10.1248 9.7516 10.1248C10.1682 10.1248 10.5071 10.4625 10.5071 10.8776V11.2531H9.00312V11.6229H10.8769V10.8776C10.8769 10.2586 10.3721 9.75495 9.75162 9.75495ZM2.05687 11.6229C1.63849 11.6229 1.31076 11.2955 1.31076 10.8776V6.75165C1.31076 6.54196 1.47721 6.37136 1.6818 6.37136H6.86277C6.79728 6.48285 6.75952 6.61286 6.75952 6.75165V10.8776C6.75952 11.1664 6.86863 11.4299 7.0475 11.6291L2.05687 11.6229Z",
    fill: "#B3B3B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7868_25675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoIcon);
export default __webpack_public_path__ + "static/media/PO_icon.7d818f9c84aa25abfd19bded5c13bfd3.svg";
export { ForwardRef as ReactComponent };